import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = ({ onAdminLogin }) => {
  const { isAdmin, logout, loading } = useAuth();

  const handleLogout = () => {
    logout();
    // 刷新页面以更新状态
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1>日拱一卒</h1>
          </Link>
          
          <nav className="nav">
            <Link to="/" className="nav-link">首页</Link>
            {isAdmin && (
              <>
                <Link to="/create" className="nav-link">写文章</Link>
                <Link to="/tasks" className="nav-link">任务管理</Link>
              </>
            )}
            
            <div className="admin-section">
              {!loading && (
                <>
                  {isAdmin && (
                    <div className="admin-controls">
                      <span className="admin-badge">管理员</span>
                      <button 
                        onClick={handleLogout}
                        className="btn btn-outline btn-sm"
                      >
                        登出
                      </button>
                    </div>
                  )
                  }
                </>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;